// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".home-container[data-v-54234d3e]{margin:30px}.home-text[data-v-54234d3e]{font-size:20px;line-height:46px}.el-carousel__item h3[data-v-54234d3e]{color:#475669;font-size:14px;opacity:.75;line-height:150px;margin:0}.el-carousel__item[data-v-54234d3e]:nth-child(2n){background-color:#99a9bf}.el-carousel__item[data-v-54234d3e]:nth-child(odd){background-color:#d3dce6}", ""]);
// Exports
module.exports = exports;
